import servicio from "./axiosServices";

export function nuevoSuscriptor(suscriptor) {
  return servicio.post("Suscriptor/", suscriptor);
}

export function validarSuscriptor(valcode) {
  return servicio.get("Suscriptor/" + valcode);
}
